import { FC } from "react";
import { IconProps } from "./types";

export const SocialFacebookFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm1.354-15.76c-.208 0-.505.104-.505.551v1.19h1.814l-.208 2.023H12.85v5.727h-2.38v-5.727H9.337V9.98h1.132v-1.31c0-.937.444-2.402 2.401-2.402l1.763.006V8.24h-1.28z"
      fill={fill}
    />
  </svg>
);
